import React from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import rzpLogo from "../assets/Logo/logo.png"
import { CheckCircle } from 'lucide-react';

export default function FeaturesPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || JSON.parse(localStorage.getItem("user"))?.email;
  const features = [
    { title: "Safety Analysis", description: "Evaluate potential hazards to ensure the safety and integrity of industrial processes." },
    { title: "Risk Identification", description: "Systematically identify and assess risks to prevent operational failures and incidents." },
    { title: "Guide Words Technique", description: 'Use guide words like "More," "Less," and "Reverse" to identify process deviations.'},
    { title: "Systematic Approach", description: "A structured and methodical examination of each stage of the process for safety and operability."},
    { title: "Scenario Analysis", description: "Analyze potential scenarios and outcomes to anticipate and mitigate risks."},
    { title: "Continuous Improvement", description: "Promote ongoing process evaluation and enhancement to maintain safety and efficiency."},
  ];

  const handleBuyPlan = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/payment/order`,{email});
      const { id: order_id, amount, currency } = response.data;

      const options = {
        key: 'rzp_test_t4LUM04KXw6wHc',
        name:"The Safety Master",
        image:rzpLogo,
        amount,
        currency,
        order_id,
        handler: async (response) => {
          try{
            const res=await axios.post(`${process.env.REACT_APP_API_URL}/payment/verify`, response);
            console.log(res)
          if(res.data.success){
            navigate('/success')
          }
          }
          catch{
            navigate('/failure')
          }
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      alert('Payment initiation failed');
    }
  };

  return (
    <div className="min-h-screen bg-gray-300">
      {/* Hero Section */}
      <div className="text-center py-16 bg-blue-400 text-white">
        <h1 className="text-4xl font-bold">Discover Amazing BBS Features</h1>
        <p className="mt-4 text-lg">Enhancing your experience with top-notch functionalities.</p>
      </div>

      {/* Feature Cards Section */}
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 ">
          {features.map((feature, index) => (
            <div key={index} 
             className="p-8 bg-white shadow-lg rounded-xl text-center  
              transition-all duration-300 hover:scale-105 hover:shadow-2xl hover: p-8 
               bg-blue-500 w-[320px] h-[220px] mx-auto">
            
            <CheckCircle className="w-14 h-14 text-blue-600 mx-auto mb-4 transition-all duration-300 hover:text-blue-800" />
            <h3 className="text-2xl font-semibold  transition-all duration-300 hover:text-blue-700">
                {feature.title}
            </h3>
            <p className="text-gray-600 mt-2 text-lg transition-all duration-300 hover:text-gray-800">
              {feature.description}
            </p>
            </div>
          ))}
        </div>
      </div>

      {/* Call to Action */}
      <div className="text-center py-12 bg-blue-400 text-white">
        <h2 className="text-3xl font-bold  animate-fadeInUp">
          Ready to Get Started?
        </h2>
        {/* <p className="mt-2 text-lg">Join us today and experience the best features.</p> */}
        <button onClick={handleBuyPlan} className="mt-4 px-6 py-3 bg-white text-blue-600 border-none font-semibold rounded-full shadow-md transition-all duration-300 transform hover:bg-gray-300  hover:scale-110 hover:shadow-lg animate-bounceOnce">
          Buy Now
        </button>
      </div>
    </div>
  );
}